import { render, staticRenderFns } from "./Modelo.vue?vue&type=template&id=0482ffac&scoped=true"
import script from "./Modelo.vue?vue&type=script&lang=js"
export * from "./Modelo.vue?vue&type=script&lang=js"
import style0 from "./Modelo.vue?vue&type=style&index=0&id=0482ffac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0482ffac",
  null
  
)

export default component.exports